import { ActivitieObject, RegistrationsObject, SintegraObjects } from "@/types";
import { useBoolValue } from "./useBoolValue";
import { useGetPartnerDealerShip } from "@/hooks/Client/useGetPartnerDealerShip";

type useReturn = {
  error: boolean;
  errorMessage: string;
  ie: string;
  errorType: string;
};

/**
 * @name useSintegraRegistrations
 * @param SintegraObject {RegistrationsObject} - Sintegra Propertie inside CNPJ Object
 * @param State {string} - Source State of CNPJ Object
 * @param Activities {ActivitieObject[]} - Array of Activities, is made on concat all Activities from Sintegra Objects: { primaryActivity, secondaryActivities }
 * @returns {useReturn} - Return Object with error, errorMessage, ie(Inscrição Estadual) if is valid and errorType
 */
function useSintegraRegistrations(
  SintegraObject: SintegraObjects,
  State: string,
  Activities: ActivitieObject[],
  Document: string
) {
  const Registration: useReturn = {
    error: true,
    errorMessage: "",
    ie: "",
    errorType: ""
  };
  // console.log("Document", Document);
  // * If the home_state_registration is not null, it will be returned.
  if (SintegraObject.hasOwnProperty("home_state_registration")) {
    Registration.ie = SintegraObject["home_state_registration"];
    Registration.error = false;
  } else {
    // * If the home_state_registration is null, we try to get the registration by filter
    // * the Registrations.registrations array, that contain multiple registrations objects.
    // * If the registration Object has state property as === State, it will be returned.
    const RegistrationByState = SintegraObject.registrations.filter(
      (registration: { state: string; enabled: string }) => {
        return registration.state === State && useBoolValue(registration.enabled);
      }
    );

    // * If the RegistrationByState is not empty, it will be returned.
    if (RegistrationByState.length > 0) {
      Registration.ie = RegistrationByState[0].number;
      Registration.error = false;
    } else {
      Registration.errorType = "notfound";
      Registration.errorMessage = "Não foi possível encontrar a inscrição estadual.";
      Registration.ie = null;
    }
  }

  // * Check if the state is a Resale
  const forbiddenActivities = [
    "4530-7/05",
    "45.30-7-05",
    "45.3.0-7/05-00",
    "4530705",
    "4530-7/02",
    "45.30-7-02",
    "45.3.0-7/02-00",
    "4530702"
  ];
  async function getPartnerDealerShip() {
    const respPartnerDealerShip = await useGetPartnerDealerShip(Document);
    if (!respPartnerDealerShip.status) {
      Activities.forEach((element: { code: string }) => {
        if (forbiddenActivities.includes(element.code)) {
          Registration.error = true;
          Registration.errorType = "resale";
          Registration.errorMessage =
            "A atividade da sua empresa (CNAE) não permite efetuar o cadastro. Cadastre outro CNPJ.";
        }
      });
    }
  }
  getPartnerDealerShip();
  return Registration;
}

export { useSintegraRegistrations };
